module.exports = __webpack_public_path__ + "static/cars-e0065cc2885cc713e3d1a6aaff014db7.jpg";